import React, { Component } from 'react';

class IconUncheckCircle extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                <g id="Ellipse_98" data-name="Ellipse 98" fill="none" stroke="#4e5b65" strokeWidth="1">
                    <circle cx="7" cy="7" r="7" stroke="none" />
                    <circle cx="7" cy="7" r="6.5" fill="none" />
                </g>
            </svg>

        );
    }
}

export default IconUncheckCircle;